/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * location vehicles request
 * @export
 * @interface LocationVehiclesRequest
 */
export interface LocationVehiclesRequest {
    /**
     * 
     * @type {Date}
     * @memberof LocationVehiclesRequest
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof LocationVehiclesRequest
     */
    jwt?: string;
}

/**
 * Check if a given object implements the LocationVehiclesRequest interface.
 */
export function instanceOfLocationVehiclesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startDate" in value;

    return isInstance;
}

export function LocationVehiclesRequestFromJSON(json: any): LocationVehiclesRequest {
    return LocationVehiclesRequestFromJSONTyped(json, false);
}

export function LocationVehiclesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationVehiclesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
    };
}

export function LocationVehiclesRequestToJSON(value?: LocationVehiclesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': (value.startDate.toISOString().substring(0,10)),
        'jwt': value.jwt,
    };
}

